import './GrandPageAnimatedSections.css'
import GrandCoursesList from '../GrandCoursesList/GrandCoursesList'
import GrandInstitutional from '../GrandInstitutional/GrandInstitutional'
import { Button, Flex, Grid } from '@mantine/core'
import grandesVideo from '../../../assets/grand/forvet_ipg_new.mp4'
import { IconArrowRight } from '@tabler/icons-react'
import HeroEventsCatalog from '../../../components/HeroEventsCatalog/HeroEventsCatalog'


const DATA = {
    "title": "Una asociación de FORVET — IPG",
    "subheading": "Una alianza que te acerca más a tus objetivos",
    "caption": "Te contamos todo",
    "video_url": grandesVideo,
    "thumbnail": "https://forvet-main.s3.sa-east-1.amazonaws.com/public/images/academicUnits/ganadería_regenerativa%3A_bases_técnicas_y_enfoque_profesional.png",
}

export default function GrandPageAnimatedSections() {


    return (
        <section className='GrandPageAnimatedSections-main-container'>
            <div className='GrandPage--hero-wrapper'>
           
                <Grid  >
                    <Grid.Col span={{ base: 12, md: 6 }}
                    classNames={{col: "GrandPage-first-text-wrapper"}} >
                        <h1 className="landingHero__title">
                            POTENCIA EL CAMPO. <br />
                            <strong>CONSTRUYE FUTURO</strong>
                        </h1>
                        <p className='GrandPage--subtitle' >GranD es la comunidad donde veterinarios de grandes animales de Latinoamérica fortalecen su criterio clínico y productivo mediante mentoría horizontal, debate de casos de campo y datos reales de nuestra región.</p>
                       <Flex justify={{base: "center", md:"start"}}>
                         <Button variant="filled" color="var(--color-grand-accent)" mt={16} rightSection={<IconArrowRight size={16} />} component="a" href='#grandes-cursos'>
                            Ver programas
                        </Button>
                       </Flex>
                    </Grid.Col>
                    <HeroEventsCatalog
                        initalData={DATA}
                    />
                </Grid>
            </div>
            <div className='GrandPageHero-second-container'>
                <GrandInstitutional />
                <GrandCoursesList />
            </div>
        </section>
    )
}

